import chroma from 'chroma-js';

import { sortByKey } from '~/core/scripts/utils';
import ac from '../appconfig';

export function parseData(dataRaw) {
  return dataRaw
    .map(d => ({
      ...d,
      wage: +d.wage
    }))
    .sort(sortByKey('wage', false));
}

export function getTimeSections(userSalary, jobSalary) {
  const salaryPerDay = userSalary / ac.daysPerMonth;

  let daysToWork = Math.round(jobSalary / salaryPerDay);

  const years = parseInt(daysToWork / ac.daysPerYear, 10);
  daysToWork -= ac.daysPerYear * years;

  const months = parseInt(daysToWork / ac.daysPerMonth, 10);
  daysToWork -= ac.daysPerMonth * months;

  return {
    years,
    months,
    days: daysToWork
  };
}

export function getUserItem(userSalary, jobSalary, data, index) {
  const isLowerThanLowest = index === 0 && userSalary < jobSalary;
  const isHigherThanHighest = index === data.length - 1 && userSalary > jobSalary;
  const isBetween = index < data.length - 1 && userSalary >= jobSalary && userSalary < data[index + 1].wage;

  return {
    isVisible: isLowerThanLowest || isHigherThanHighest || isBetween,
    isBefore: isLowerThanLowest
  };
}

export const colorScale = chroma
  .scale(ac.colors)
  .mode('lch')
  .domain(ac.colorDomain);

export default {
  parseData,
  getTimeSections,
  getUserItem,
  colorScale
};
